import { CmProAuthService } from './cmpro-auth.service';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { AkitaAuthStore } from '../store/auth/akita-auth.store';
import { Observable, of } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { UsersBus } from '../../cp/shared/models/UsersBus.model';
import { AuthenticationService } from '../../cp/shared/services/authentication.service';
import { AppClaims } from '@app/cp/shared/models/AppClaims';
import { GlobalsService } from '@app/cp/shared/services/globals.service';
import { BaseMessageInfo } from '../../cp/shared/models/BaseMessageInfo';
import { JwtHelperService } from '@auth0/angular-jwt';

export type Creds = { username: string, password: string; };
export type AuthenticateCreds = { userId: string, sessionId: string; };

/**
 * @deprecated This class is deprecated and will be removed in future versions.
 */
@Injectable()
export class AkitaAuthService {

    constructor(private authStore: AkitaAuthStore, private router: Router, private authenticationService: AuthenticationService, private globals: GlobalsService, private cmProAuthService: CmProAuthService) { }

    login(creds: Creds) {
        return this.callServer(creds).pipe(
            map((user: UsersBus) => {
                const usr = new UsersBus(user);
                const newUser = this.cmProAuthService.parseUserResponse(usr);
                this.authStore.login(newUser);
                const redirect = this.globals.redirectURL ?? "";
                if (redirect.length > 0) {
                    this.router.navigate([this.globals.redirectURL]);
                } else {
                    this.router.navigate(['/']);
                }
            }),
            catchError(error => of(error))
        );
    }

    appAuthenticate(creds: AuthenticateCreds) {
        return this.callServerAuth(creds).pipe(
            map((user: UsersBus) => {
                user = new UsersBus(user);
                let tokenDecoded = this.cmProAuthService.decodeToken(user.token);
                user.appClaims = new AppClaims(tokenDecoded);
                console.log("login: ", user, tokenDecoded);
                this.authStore.login(user);
                localStorage.setItem('userAuth', JSON.stringify(user));
                if (this.globals.redirectURL.length > 0) {
                    this.router.navigate([this.globals.redirectURL]);
                } else {
                    this.router.navigate(['/']);
                }
            }),
            catchError(error => of(error))
        );
    }

    logout(callback: any = null) {
        localStorage.removeItem('userAuth');
        this.authStore.logout();
        if (callback) {
            callback();
        } else {
            this.router.navigate(['/login']);
        }
    }

    private callServer({ username, password }: Creds): Observable<UsersBus> {
        return this.authenticationService.postLogin(username, password);
    }

    private callServerAuth({ userId, sessionId }: AuthenticateCreds): Observable<UsersBus> {
        return this.authenticationService.postAuthenticate(userId, sessionId);
    }
    public callCheckResetPassword(resetId: string): Observable<boolean> {
        return this.authenticationService.postCheckResetPassword(resetId);
    }
    public callResetPassword(resetId: string, password: string): Observable<BaseMessageInfo> {
        return this.authenticationService.postResetPassword(resetId, password);
    }
    public ForgotPasswordMo(email: string): Observable<BaseMessageInfo> {
        return this.authenticationService.ForgotPasswordMo(email);
    }
    //ForgotPasswordMo
    isTokenExpired(token): boolean | Promise<boolean> {
        if (token) {
            let jwtHelper = new JwtHelperService({
                tokenGetter: () => {
                    return token;
                }
            });
            let expirationDate = jwtHelper.getTokenExpirationDate();
            let isExpired = jwtHelper.isTokenExpired();
            return isExpired;
        }

    }

}
